import React from "react";
import { Box, Button, Dialog, Stack, Typography } from "@mui/material";




const DialogDelete = ({
    show,
    onClose,
    query = "Are you sure you wish to permanently delete",
    item = "",
    onDelete,
    onCancel = null,
    deleteName = "Delete"
}) => {

    const getQuery = () => {
        return query + "?"
    }

    const myCancel = () => {
        if (onCancel !== null) {
            onCancel()
        }
        onClose()
    }

    const myDelete = () => {
        onDelete()
        onClose()
    }



    return (
        <>
            {show && (
                < Dialog
                    sx={{
                        overflow: "scroll",
                        "& .MuiDialog-container": {
                            display: "inline-flex !important",
                            // justifyContent: "center",
                            // alignItems: "centert",
                            //overflow: "scroll",
                            // mt: 30,
                            // mx: 30,
                            width: "100%",
                            // minWidth: 1800,

                        },
                    }}

                    //fullWidth={true}
                    width="60%"
                    maxWidth="100%"
                    open={show}
                    onClose={onClose}
                //disableEscapeKeyDown={true}
                >
                    <Stack spacing={5}>
                        <Typography sx={{ mx: 10, px: 10, pt: 10, display: "flex", justifyContent: "center", }} id="delete" variant="h7" gutterBottom>
                            {getQuery()}
                        </Typography>
                        {item &&
                            <Typography sx={{ mx: 10, px: 10, display: "flex", justifyContent: "center", }} id="delete" variant="h6" fontWeight={"bold"} color="error" gutterBottom>
                                {item}
                            </Typography>
                        }
                        <Typography sx={{ display: "flex", justifyContent: "center", }} id="delete" variant="body1" gutterBottom>
                            {"This cannot be undone."}
                        </Typography>
                        <Box sx={{ pt: 10, pb: 10, display: "flex", alignContent: "center", justifyContent: "center" }}>
                            <Stack direction="row" spacing={10}>
                                <Button variant="contained" color="secondary" onClick={myCancel}>
                                    Cancel
                                </Button>
                                <Button variant="contained" onClick={myDelete}            >
                                    {deleteName}
                                </Button>
                            </Stack>
                        </Box>
                    </Stack>

                </Dialog >
            )}
        </>
    )
}

export default DialogDelete;